import { createApp } from "vue";
import { upperFirst, camelCase } from "lodash";
import { trackVideoEvents, trackButtonClickEventsBySelector } from "@/analyticsHelper";
import { SwiperSlide } from "swiper/vue";
import axios from "axios";
import maska from "maska";

window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

const app = createApp({});
const requireComponent = require.context("@/components/", true, /.vue$/);
const statamicSnippetsDecoded = JSON.parse(atob(document.querySelector("meta[name=js_snippets]").content));

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(
        camelCase(
            fileName
                .split("/")
                .pop()
                .replace(/\.\w+$/, "")
        )
    );

    app.component(componentName, componentConfig.default || componentConfig);
});

app.use(maska);
app.component("SwiperSlide", SwiperSlide);
app.provide("statamic_snippets", statamicSnippetsDecoded);

app.mount("#app");

function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {
    const videoElements = document.getElementsByClassName("js-hook-load-video-iframe");

    const playVideo = (event) => {
        const parentElement = event.target.parentNode;

        const videoElement = document.createElement("video");
        videoElement.autoplay = true;
        videoElement.muted = true;
        videoElement.loop = true;
        videoElement.controls = true;
        videoElement.playsInline = true;

        trackVideoEvents(videoElement);

        const videoClasses = parentElement.dataset.videoClass.split(" ");

        videoElement.classList.add(...videoClasses);

        const sourceElement = document.createElement("source");
        sourceElement.src = parentElement.dataset.videoSrc;
        videoElement.appendChild(sourceElement);

        while (parentElement.firstChild) {
            parentElement.removeChild(parentElement.firstChild);
        }

        parentElement.replaceWith(videoElement);
        parentElement.removeEventListener("click", playVideo);
    };

    Array.from(videoElements).forEach((el) => el.addEventListener("click", playVideo));

    const addTrackingToButtons = () => {
        trackButtonClickEventsBySelector(
            'a[href="/solliciteren"], .analytics_apply_click_track',
            "button_click_solliciteren"
        );

        trackButtonClickEventsBySelector(".analytics_social_click_track", "button_click_social");
    };

    const observer = new MutationObserver(addTrackingToButtons);

    addTrackingToButtons();
    observer.observe(document, {
        subtree: true,
        childList: true,
    });
});

// <editor-fold desc="Script section from Spatie\ResponsiveImages">
window.addEventListener("load", () => {
    window.responsiveResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
            const imgWidth = entry.target.getBoundingClientRect().width;
            entry.target.parentNode.querySelectorAll("source").forEach((source) => {
                source.sizes = `${Math.ceil((imgWidth / window.innerWidth) * 100)}vw`;
            });
        });
    });

    document.querySelectorAll("[data-statamic-responsive-images]").forEach((responsiveImage) => {
        window.responsiveResizeObserver.onload = null;
        window.responsiveResizeObserver.observe(responsiveImage);
    });
});
// </editor-fold>
